import i18n from ".";
import { ru } from "./ru";

const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Шаблоны ru.validation → регулярки: «Минимум {{n}} символов» → /^Минимум (.+?) символов$/. */
const PATTERNS = Object.entries(ru.validation).map(([key, tpl]) => {
  const names: string[] = [];
  const source = escape(tpl).replace(/\\\{\\\{(\w+)\\\}\\\}/g, (_, n: string) => {
    names.push(n);
    return "(.+?)";
  });
  return { key, re: new RegExp(`^${source}$`), names };
});

/**
 * Сообщения валидации из @cafe/shared (и с сервера) написаны на ru — на других языках
 * ищем совпадение с шаблоном словаря validation.* и подставляем перевод. Неизвестные — как есть.
 */
export function translateValidation(message: string): string {
  if (!message || i18n.language === "ru") return message;
  for (const p of PATTERNS) {
    const m = p.re.exec(message);
    // Простая сигнатура: полная типизация ключей здесь не нужна, а на большом словаре упирается в глубину типов TS
    if (m) return (i18n.t as (key: string, options?: Record<string, unknown>) => string)(`validation.${p.key}`, Object.fromEntries(p.names.map((n, i) => [n, m[i + 1]])));
  }
  return message;
}

/** Переводит все message в дереве ошибок react-hook-form (вложенные поля и массивы). */
export function translateErrorTree<T>(errors: T): T {
  if (!errors || typeof errors !== "object") return errors;
  for (const [k, v] of Object.entries(errors as Record<string, unknown>)) {
    if (k === "ref") continue;
    if (k === "message" && typeof v === "string") (errors as Record<string, unknown>)[k] = translateValidation(v);
    else if (v && typeof v === "object") translateErrorTree(v);
  }
  return errors;
}
